import type { PageSnapshot } from "../context/types";
import type { Offer, Playbook } from "./types";
import { PLAYBOOKS } from "./registry";

export function selectOffer(
  s: PageSnapshot | null,
  dismissed: Set<string>,
  playbooks: Playbook[] = PLAYBOOKS,
): Offer | null {
  if (!s) return null;
  const candidates = playbooks
    .filter((p) => p.app === s.app)
    .sort((a, b) => b.priority - a.priority);
  for (const p of candidates) {
    const offer = p.match(s);
    if (offer && !dismissed.has(offer.key)) return offer;
  }
  return null;
}
